import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "pl-4 lg:pl-20 py-14 font-poppins" }
const _hoisted_3 = { class: "grid grid-cols-2 lg:grid-cols-4" }
const _hoisted_4 = {
  key: 0,
  class: "col-span-1"
}
const _hoisted_5 = ["href"]

import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'Legacy',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full bg-legal" }, [
      _createElementVNode("div", { class: "py-20 px-4 lg:px-24" }, [
        _createElementVNode("h1", { class: "font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28" }, [
          _createTextVNode("Legacy "),
          _createElementVNode("br"),
          _createTextVNode("Documents")
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(legalDocuments).legacy.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-xl mt-10 mb-5 font-bold" }, "Legacy Critical Information Summaries (formerly Harbour ISP) ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).legacy, (legalDocument) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "mb-5",
                      key: legalDocument.name
                    }, [
                      _createElementVNode("a", {
                        href: legalDocument.url,
                        class: "text-black hover:text-black hover:underline transition duration-250",
                        target: "_blank"
                      }, _toDisplayString(legalDocument.name), 9, _hoisted_5)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})